exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-valid[data-v-38b5cccf]{\n  border-color: #28a745;\n}\n", ""]);

// exports
